module.exports = __webpack_public_path__ + "img/slide_interno_granola.01ed58aa.webp";